import { useQuery } from "@tanstack/react-query";
import { getBlogs } from "../../api/apiBlogs";
import i18next from "i18next";

/**
 * Hook لجلب قائمة المدونات المفلترة
 * @param {Object} params - Query parameters (page, per_page, search, trashed)
 */
export function useGetBlogs(params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["blogs", params, i18next.language],
        queryFn: () => getBlogs(params),
        retry: false,
    });

    const blogs = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, blogs, meta, refetch };
}
